import { render, staticRenderFns } from "./Empleado.vue?vue&type=template&id=50e4ad5f&scoped=true&"
import script from "./Empleado.vue?vue&type=script&lang=js&"
export * from "./Empleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4ad5f",
  null
  
)

export default component.exports